import React, {Component} from 'react';
import ItemContainer from 'items/ItemContainer';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import BootstrapTable from 'react-bootstrap-table-next';
import {FormattedDate} from 'react-intl';
import {Money} from 'items/ItemList';
import autobind from 'autobind-decorator';
import {TYPE_CHOICES} from 'items/Item';
import {Button} from 'reactstrap';
import {getURL} from 'apa/actions/generic'

@connect(
    state => ({
        auth: state.apa,
        items: state.items
    }),
    null
)
export default class Overview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            overviewList: null,
            isDownloading: false
        }
    }

    @autobind
    fetchOverviewList(year = null, month = null, quarter = null) {
        this.setState({
            isLoading: true
        });
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const data = {
            year: year ? year : this.props.items.currentYear,
            month: month ? month : this.props.items.currentMonth,
            quarter: quarter ? quarter : this.props.items.currentQuarter,
        };
        fetch(
            getURL('/api/overview/', data),
            {headers}
        )
            .then(res => res.json())
            .then(overview => this.setState({
                    isLoading: false,
                    overviewList: overview
                }
            ))

    }

    componentDidMount() {
        this.fetchOverviewList()
    }

    @autobind
    downloadExcel() {
        if (this.state.isDownloading)
            return;
        this.setState({
            isDownloading: true
        })
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`
        };
        const items = this.props.items;
        const data = {
            year: items.currentYear,
            month: items.currentMonth,
            quarter: items.currentQuarter,
            type: items.currentType
        };
        fetch(
            getURL('/api/overview/export/', data),
            {headers}
        )
            .then(
                response => response.blob()
            )
            .then(
                blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
										a.download = 'Übersicht-'+items.currentYear+'-'+items.currentMonth+'.docx';
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.remove();  //afterwards we remove the element again
                    this.setState({
                        isDownloading: false
                    })
                }
            )
    }

    render() {
        if (this.state.isLoading)
            return <Loading/>;
        const columnList = [
            {
                dataField: 'datum',
                text: 'Monat',
                formatter: cell => <FormattedDate value={cell} month={'2-digit'} year={'numeric'}/>
            },
            {
                dataField: 'art',
                text: 'Art',
                formatter: cell => TYPE_CHOICES[cell]
            },
            {
                dataField: 'gesamt_ausgaben_brutto',
                text: 'Ausgaben (brutto)',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'gesamt_einnahmen_brutto',
                text: 'Einnahmen (brutto)',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'gesamt_ausgaben_netto',
                text: 'Ausgaben (netto)',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'gesamt_einnahmen_netto',
                text: 'Einnahmen (netto)',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'mwst_ausgaben',
                text: 'MwSt Ausgaben',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'mwst_einnahmen',
                text: 'MwSt Einnahmen',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'zu_zahlende',
                text: 'Zu zahlende',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'guthaben',
                text: 'Guthaben',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
            {
                dataField: 'deposits',
                text: 'Einzahlung',
                formatter: cell => Money(cell),
                classes: 'text-right',
                headerClasses: 'text-right'
            },
        ];
        return (
            <ItemContainer callback={this.fetchOverviewList}>
                <Button color={'primary'} onClick={this.downloadExcel}
                        disabled={this.state.isDownloading}>
                    {this.state.isDownloading &&
                    <i className='fa fa-spinner fa-spin'> </i>
                    }
                    Download
                </Button>
                <BootstrapTable
                    keyField='id'
                    data={this.state.overviewList}
                    columns={columnList}
                    striped
                    bootstrap4
                />
            </ItemContainer>
        )
    }

}
